import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { icons, services } from '@/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      tooltip: undefined
    }
  },

  computed: {
    status() {
      const result = {
        icon: icons.error_outline,
        color: Colors.error,
        tooltip: this.getTranslate(`${services.yclients}.tooltips.notActive`)
      }
      if (this.value.isActive) {
        result.icon = icons.check_circle_outline,
        result.color = Colors.success,
        result.tooltip = this.getTranslate(`${services.yclients}.tooltips.active`)
      }

      return result
    },

    /**
     * Текст ошибки записи для показа и подсказки.
     *
     * Поле error записи не обязательно содержит JSON. Ошибка разбора
     * подавляется: в этом случае в блоке finally подставляется исходная строка.
     *
     * @returns {string|undefined} Текст ошибки или `undefined`, если ошибки нет.
     */
    error() {
      let result
      try {
        const error = JSON.parse(this.value.error)
        if (error) {
          const message = get(error, 'meta.message')
          if (message) {
            this.tooltip = message
            result = message
          }
        }
      } catch (error) {
      } finally {
        if (this.value.error && !result) {
          this.tooltip = this.value.error
          result = this.value.error
        }
      }

      return result
    }
  },

  render
}
